import React, { useEffect, useState } from 'react';

import Container from 'components/Container';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useLocation } from 'react-router-dom';

import { Alert, Snackbar } from '@mui/material';
/* eslint-disable react/no-unescaped-entities */
import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
// import Card from '@mui/material/Card';
// import Divider from '@mui/material/Divider';
// import useMediaQuery from '@mui/material/useMediaQuery';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import FormDialog from './FormDialogue';
import AlertDialogSlide from './MailPop';
import SuccessMessage from './success';
import { assets } from 'assets/assets';

const Hero = () => {
  const theme = useTheme();
  // const isMd = useMediaQuery(theme.breakpoints.up('md'), {
  //   defaultMatches: true,
  // });
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const [confirmToken, setSetConfirmToken] = useState('');
  const [confirmSeminar, setConfirmSeminar] = useState(false);

  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const location = useLocation();

  useEffect(() => {
    if (location.search) {
      const token = new URLSearchParams(location.search).get('token');
      const confirm = new URLSearchParams(location.search).get('confirm');

      setSetConfirmToken(token);
      setConfirmSeminar(confirm === 'true');
      setOpenConfirmModal(true);
    }
  }, []);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackBar(false);
  };

  const GridItemHeadlineBlock = () => (
    <Box marginBottom={4} data-aos="fade-up">
      <Typography
        variant="h3"
        gutterBottom
        sx={{
          fontWeight: 900,
          color: 'common.white',
        }}
      >
        Join our community
      </Typography>
      <Typography
        variant="h6"
        component="p"
        color="text.primary"
        sx={{
          fontWeight: 500,
          color: 'common.white',
        }}
      >
        Did you miss out on Tech "n" Chills? Keep an eye open as we are
        currently cooking something new already, be the first to know when you
        join our community.
        <br />
        Join us as we learn, network, have fun and grant access to free
        resources to help you start and scale up a career in Tech.
        {/* We are zealous, curious, goal-driven, and committed to doing great work;
        we are always looking for creative and talented people to join our team. */}
      </Typography>
      <Box
        marginTop={5}
        // display="flex"
        // flexDirection={{ xs: 'column', sm: 'row' }}
        // alignItems={{ xs: 'stretched', sm: 'flex-start' }}
      >
        <FormDialog />
      </Box>
    </Box>
  );

  const GridItemLeftBlock = () => (
    <Box
      sx={{
        height: { xs: 'auto', md: 1 },
        '& img': {
          objectFit: 'cover',
        },
        '& .lazy-load-image-loaded': {
          height: 1,
          width: 1,
        },
      }}
    >
      <Box
        component={LazyLoadImage}
        effect="blur"
        src={assets.eventSection.heroImage}
        height="100%"
        width="100%"
        margin={0}
      />
    </Box>
  );

  return (
    <Box
      minHeight={300}
      height={'auto'}
      position={'relative'}
      sx={{
        marginTop: -16,
        paddingTop: 13,
        backgroundColor: theme.palette.alternate.main,
        background: `url(${assets.eventSection.imageBackground}) no-repeat center`,
        backgroundSize: 'cover',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: 1,
          height: 1,
          backgroundColor: theme.palette.primary.main,
          backgroundImage: `linear-gradient(315deg, ${theme.palette.primary.main} 0%, #000000 74%)`,
          opacity: '0.8',
          zIndex: 1,
        }}
      />
      <Container position={'relative'} zIndex={2}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Box width={1} height="100%" display="flex" alignItems="center">
              <GridItemHeadlineBlock />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box width={1} height="100%" display="flex" alignItems="center">
              <GridItemLeftBlock />
            </Box>
          </Grid>
        </Grid>
        <AlertDialogSlide
          openConfirmModal={openConfirmModal}
          setOpenConfirmModal={setOpenConfirmModal}
          confirmToken={confirmToken}
          confirmSeminar={confirmSeminar}
          setOpenSuccessModal={setOpenSuccessModal}
          setErrorMessage={setErrorMessage}
          setOpenSnackBar={setOpenSnackBar}
        />
        <SuccessMessage
          openSuccessModal={openSuccessModal}
          setOpenSuccessModal={setOpenSuccessModal}
        />
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={openSnackBar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          color={'red'}
          // action={action}
        >
          <Alert
            onClose={handleCloseSnackbar}
            onClick={handleCloseSnackbar}
            severity="error"
            sx={{ width: '100%' }}
          >
            {errorMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Box>
  );
};

export default Hero;
